const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export const HomeIcon = ({ active, className }) => (
  <svg {...base} className={className} fill={active ? 'currentColor' : 'none'}>
    <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5H10v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5Z" />
  </svg>
);

export const MapsIcon = ({ active, className }) => (
  <svg {...base} className={className}>
    <path
      d="M2 3L8.5 6L15.5 3L22 6V21L15.5 18L8.5 21L2 18V3Z"
      fill={active ? 'currentColor' : 'none'}
    />
    <path d="M8.5 6V21M15.5 3V18" stroke={active ? 'white' : 'currentColor'} />
  </svg>
);

export const SearchIcon = ({ active, className }) => (
  <svg {...base} className={className} strokeWidth={active ? 3 : 2}>
    <circle cx="11" cy="11" r="7" />
    <path d="M17 17l4 4" />
  </svg>
);

export const ProfileIcon = ({ active, className }) => (
  <svg {...base} className={className} fill={active ? 'currentColor' : 'none'}>
    <circle cx="12" cy="7" r="4" />
    <path d="M4 21c0-3.866 3.582-7 8-7s8 3.134 8 7" />
  </svg>
);

export const MenuIcon = ({ className }) => (
  <svg {...base} className={className}>
    <path d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);
